import React from 'react';
import AdminBleedArea from './AdminBleedArea';
import './AdminTwoColumn.css';

/**
 * @param {{
 *   sidebar?: React.ReactNode,
 *   children?: React.ReactNode,
 *   className?: string
 * }} props
 */
function AdminTwoColumn({ sidebar = null, children, className = '' }) {
  return (
    <AdminBleedArea>
      <div className={`au-two-column au-scope${className ? ` ${className}` : ''}`}>
        {sidebar ? <div className="au-two-column__sidebar">{sidebar}</div> : null}
        <div className="au-two-column__main">{children}</div>
      </div>
    </AdminBleedArea>
  );
}

export default AdminTwoColumn;
